import React, { useState, useEffect } from 'react';
import { File } from '../abstractComponent/File';
import { Category } from '../abstractComponent/Category';
import { Video } from '../abstractComponent/Video';
import { getSortedItems } from '../helpers/filter';

import  PageHeader  from '../pageComponent/PageHeader';
import  Bandeau  from '../pageComponent/Bandeau';
import  Breadcrumb  from '../pageComponent/Breadcrumb';
import  TagBreadcrumb from '../pageComponent/TagBreadcrumb';
import  SearchBreadcrumb from '../pageComponent/SearchBreadcrumb';
import  Footer  from '../pageComponent/Footer';
import './Mediatheque.css';


export default function Mediatheque({ routerQuery, tree, lang = 'EN' }) {

    //const router = useRouter();
    let [search, setSearch] = useState('');
    let tagURL = null;

    //check if its a tags URL
    if(routerQuery[0]) {
        if(routerQuery[0].slice(0,5) === 'tags=') {
            tagURL = routerQuery[0].slice(5);
        }
    }

    //extract items according to types of files / link 
    const { items, categoryItems, fileItems, videoItems } = getSortedItems(routerQuery, tree, lang, search);

    let breadcrumbPath = items[0] ? items[0].path : '';
    breadcrumbPath = breadcrumbPath.split('\\').slice(1,-1) || [];
    breadcrumbPath = breadcrumbPath.map((i) => {
        return i.split('_')[1];
    });

    const setSearchTerm = function(e) {
        setSearch(e.target.value.toLowerCase());
    }

    useEffect(() => {
        setSearch('');
    },[routerQuery]);

    return (
        <>
        <PageHeader lang={lang}></PageHeader>
        <Bandeau items={items} lang={lang} search={search} setSearch={setSearchTerm}></Bandeau>
        {search.length > 2 && <SearchBreadcrumb search={search}></SearchBreadcrumb>}
        {search.length <= 2 && tagURL && <TagBreadcrumb tags={tagURL}></TagBreadcrumb>}
        {search.length <= 2 && !tagURL && <Breadcrumb path={breadcrumbPath}></Breadcrumb>}

        <div className="container">
        {!tree.length && <div style={{textAlign: 'center', margin: '50px'}}><div>Chargement de la médiathèque <br></br><br></br> <div className="lds-roller"><div /><div /><div /><div /><div /><div /><div /><div /></div> </div></div>}
        {categoryItems.length ? <div className="vignettes-container"><Category items={categoryItems} lang={lang}></Category></div>  : null } 
        {fileItems.length     ? <div className="vignettes-container"><File items={fileItems} lang={lang}></File></div> : null }
        {videoItems.length    ? <div className="vignettes-container"><Video items={videoItems} lang={lang}></Video></div> : null }
        </div>
        <Footer lang={lang}></Footer>
        </>
    )
}


